// ============================================================================
// crmVigia · as regras do vigia de mensagem nova do CRM (30/10/2026, CRM_VIGIA)
// ============================================================================
// Pedido do dono (30/10/2026): "Preciso fazer notificação de mensagem para quando a
// recepcionista estiver no computador e estiver fora do DNA, por exemplo no Avec, ou
// então para quando ela estiver em outra aba do DNA e não tiver no CRM. Como não está
// chegando nenhuma notificação nem nada, elas estão se perdendo. O som também não está
// funcionando."
// O vigia (src/components/crm/VigiaCrm.jsx) mora no Layout, em todas as telas, para
// quem tem o CRM no menu e SÓ NO COMPUTADOR. Aqui só as regras, sem React (testadas no node):
//   · o portão: o MESMO do item "CRM da Sofia" do Sidebar e o computador (eComputador do
//     contrato; iPad com Safari conta, é o balcão); no celular nada muda (vigiaLigadoPara);
//   · uma aba LÍDER por navegador (criarLideranca): navigator.locks 'fk-crm-vigia';
//     sem Web Locks, a reserva por batida no localStorage (10 s; a líder some depois de
//     90 s sem bater, que é mais que o 1 minuto do Chrome com a aba escondida). Só a
//     líder lê e avisa; as outras só põem o "(N)" no título (CHAVE_VIGIA_TOTAL);
//   · quando ler (criarAgenda): no aviso do canal ao vivo, no máximo 1 leitura a cada
//     30 s de dia e 60 s das 21h às 8h (São Paulo); com a Caixa à vista neste navegador o
//     aviso do canal nem antecipa (a Caixa já lê na hora); a reserva, 60 s sem o canal
//     provado e 180 s com ele; à noite, 5 min. Lê com a aba escondida também (o Avec);
//   · a recusa passageira não desliga (depoisDaFalha): só para de vez com 404 (rollout
//     off) ou sem o token da sessão; 401 e 403 esperam 5 min e 3 seguidas param (o Vigia
//     remonta quando a sessão muda); 409 (sem a crm-007) espera 10 min;
//   · o carimbo do op avisos (processarLeitura): a líder manda o da leitura anterior e,
//     com mudou: false, mantém o total e o antes como estão (só a hora da leitura anda);
//   · o que é novidade (processarLeitura): a fala do cliente mais nova que o já avisado
//     (crmAvisados.js) e que a última leitura boa (CHAVE_VIGIA_DESDE, sobrevive à recarga
//     pelo deploy: o que chegou durante a recarga ainda avisa). Primeira vez na vida do
//     navegador: só semeia. Conversa que já estava na leitura anterior compara com a hora
//     de lá; a que não estava, com a última leitura menos 30 s (a fala gravada no mesmo
//     instante da leitura anterior não se perde);
//   · UM SOM SÓ, SEMPRE (criarAvisador, uma decisão por leva):
//       a Caixa à vista e com foco toca sozinha;
//       com o push do computador ativo, o vigia não toca nada por conta própria: o service
//       worker grava a chegada (CHAVE_PUSH_CHEGOU, gravarChegada) e pede o som à janela do
//       DNA em foco (MSG_PUSH_CHEGOU com pedirSom, criarLeitorDoServiceWorker); a fala que
//       a chegada cobre (chegadaCobre) só é marcada; a que não, espera ESPERA_PUSH_MS e
//       confere de novo (chegou? o aviso na tela?); só o que o servidor não mandou (fora do
//       expediente, fora da régua, falha) cai no caminho sem push;
//       sem push: a líder com foco toca; senão pede à aba em foco (CHAVE_VIGIA_TOCAR e a
//       resposta em CHAVE_VIGIA_TOCOU, pedirSomNaAbaComFoco); som travado = o aviso do
//       canto lá E o aviso do navegador aqui (o som do sistema), com a permissão; ninguém
//       em foco = o aviso do navegador com a permissão, senão o som na própria líder; o
//       aviso do navegador nunca sai com o push daquela conversa na tela (depoisDoPedido);
//   · o título "(N) " de todas as telas fora do CRM (tituloComContagem).
// As chaves e as esperas são as do contrato (crmAvisoContrato.js), reexportadas aqui.
// ============================================================================

import {
  CHAVE_VIGIA_DESDE, CHAVE_VIGIA_TOTAL, CHAVE_LIDER, CHAVE_PUSH_CHEGOU, PUSH_CHEGOU_TTL_MS, PUSH_CHEGOU_MAX,
  CHAVE_VIGIA_TOCAR, CHAVE_VIGIA_TOCOU, ESPERA_TOCOU_MS, ESPERA_PUSH_MS, MSG_ABRIR_CONVERSA, MSG_PUSH_CHEGOU,
  PREFIXO_TAG_AVISO, TIPO_AVISO_MENSAGEM, tagAvisoMensagem,
} from './crmAvisoContrato.js';
import { lerAvisados, marcarAvisados, naoAvisados, jaAvisado } from './crmAvisados.js';

export { CHAVE_LIDER, CHAVE_PUSH_CHEGOU, CHAVE_VIGIA_TOCAR, CHAVE_VIGIA_TOCOU, ESPERA_TOCOU_MS, ESPERA_PUSH_MS };

export const NOME_TRAVA = 'fk-crm-vigia';
export const BATIDA_LIDER_MS = 10_000;
export const VALIDADE_LIDER_MS = 90_000;
/** O aviso do canal ao vivo lê no máximo 1 vez a cada 30 s de dia e 60 s à noite (30/10/2026, revisão: era 20 s). */
export const LEITURA_MIN_MS = 30_000;
export const LEITURA_MIN_NOITE_MS = 60_000;
export const RESERVA_MS = Object.freeze({ semCanal: 60_000, comCanal: 180_000, noite: 5 * 60_000 });
export const NOITE_SP = Object.freeze({ de: 21, ate: 8 });
export const FOLGA_GRAVACAO_MS = 30_000;
export const TOTAL_VALIDADE_MS = 10 * 60_000;
export const ESPERA_SEM_007_MS = 10 * 60_000;
/** 401 e 403 do servidor: espera 5 min; 3 seguidas, para até a sessão mudar. */
export const ESPERA_RECUSA_MS = 5 * 60_000;
export const MAX_RECUSAS = 3;
/** A chegada gravada sem a hora da fala (servidor antigo) cobre a conversa por 10 min. */
export const CHEGADA_SEM_EM_MS = 10 * 60_000;
/** O pedido de som mais velho que isto (relógio da outra aba) não toca. */
export const PEDIDO_VELHO_MS = 10_000;
/** As respostas de quem tocou (as mesmas de crmSom.tocarAviso). */
export const RESPOSTAS_DO_SOM = Object.freeze(['tocou', 'intervalo', 'travado', 'mudo']);
export const ROTA_CRM = '/gestao/crm-sofia';

const ms = (v) => (v ? Date.parse(v) : Number.NaN);
const isoOuNulo = (v) => { const n = typeof v === 'string' ? Date.parse(v) : Number.NaN; return Number.isFinite(n) ? new Date(n).toISOString() : null; };
const ouviu = (r) => r === 'tocou' || r === 'intervalo';

function armazem() {
  try { return typeof window !== 'undefined' && window.localStorage ? window.localStorage : null; } catch { return null; }
}
function lerJson(storage, chave) {
  try { const b = storage ? storage.getItem(chave) : null; return b ? JSON.parse(b) : null; } catch { return null; }
}
function gravarJson(storage, chave, v) {
  try { if (storage) { storage.setItem(chave, JSON.stringify(v)); return true; } } catch { /* sem armazenamento */ }
  return false;
}
// storage undefined = o localStorage de agora; null = sem armazenamento (os testes passam um falso)
const qualArmazem = (storage) => (storage === undefined ? armazem() : storage);

// ─── o portão (o mesmo do Sidebar, e só no computador) ─────────────────────

/** A gerente e a recepção só têm o item quando o servidor libera (useAtendimentoAcesso); o cargo vem do cadastro. */
export function usaFilaNoMenu({ user, papel, iaMenu }) {
  if (!iaMenu || !user) return false;
  if (papel === 'Recepcionista') return true;
  return user.role === 'admin' && papel === 'Gerente';
}
/**
 * comCrm do Sidebar (CRM_SOFIA_MENU && IA_ATENDENTE_MENU && (fila liberada || master)), o interruptor do vigia e o
 * computador (30/10/2026, revisão: no celular a Caixa segue tocando dentro do CRM como antes, sem vigia).
 */
export function vigiaLigadoPara({ vigia, crmMenu, iaMenu, usaFila, podeFila, isMaster, computador = false }) {
  return !!vigia && !!computador && !!crmMenu && !!iaMenu && ((!!usaFila && !!podeFila) || !!isMaster);
}

// ─── o relógio de São Paulo (sem horário de verão desde 2019) ──────────────

export function horaEmSP(agoraMs) {
  try {
    const h = Number(new Intl.DateTimeFormat('en-US', { timeZone: 'America/Sao_Paulo', hour: 'numeric', hourCycle: 'h23' }).format(new Date(agoraMs)));
    if (Number.isInteger(h) && h >= 0 && h < 24) return h;
  } catch { /* sem Intl: UTC-3 */ }
  return (new Date(agoraMs).getUTCHours() + 21) % 24;
}
export const ehNoiteSP = (agoraMs) => { const h = horaEmSP(agoraMs); return h >= NOITE_SP.de || h < NOITE_SP.ate; };

/** A espera da reserva desde a última leitura: 5 min à noite; 180 s com o canal provado; 60 s sem ele. */
export function esperaDaReserva({ aoVivo = false, agoraMs = Date.now() } = {}) {
  if (ehNoiteSP(agoraMs)) return RESERVA_MS.noite;
  return aoVivo ? RESERVA_MS.comCanal : RESERVA_MS.semCanal;
}
/** O mínimo entre duas leituras pelo aviso do canal: 30 s de dia, 60 s das 21h às 8h. */
export const minimoDoSinal = (agoraMs = Date.now()) => (ehNoiteSP(agoraMs) ? LEITURA_MIN_NOITE_MS : LEITURA_MIN_MS);

// ─── a decisão de cada leva ────────────────────────────────────────────────

/**
 * Sem push: → 'caixa' (a Caixa do CRM à vista e com foco toca sozinha) | 'som' (a própria líder tem foco: toca)
 *   | 'pedir' (pede o som à aba do DNA em foco).
 */
export function decidirSemPush({ caixaAtiva = false, temFoco = false } = {}) {
  if (caixaAtiva) return 'caixa';
  if (temFoco) return 'som';
  return 'pedir';
}
/**
 * → 'caixa' | 'push' (o push do computador ativo: o vigia não toca nada, confere a chegada) | 'som' | 'pedir'.
 * Com o push, o foco não importa: o service worker pede o som à janela em foco (MSG_PUSH_CHEGOU).
 */
export function decidirAviso({ caixaAtiva = false, temFoco = false, pushComputador = false } = {}) {
  if (caixaAtiva) return 'caixa';
  if (pushComputador) return 'push';
  return decidirSemPush({ caixaAtiva, temFoco });
}
/**
 * Depois do toque (da aba em foco ou da própria líder). r = 'tocou' | 'intervalo' | 'travado' | 'mudo' | null
 * (ninguém em foco respondeu); pushNaTela = o push daquela conversa está na tela (true | false | null);
 * liderTentou = quem tentou foi a própria líder (não tenta de novo).
 * → 'feito' (ouviu, ou o push já está na tela: só marca) | 'mudo' (o som desligado nas preferências: nada)
 *   | 'aviso' (o aviso do navegador da página, com a permissão) | 'som' (o som na própria líder) | 'nada'
 */
export function depoisDoPedido({ r = null, permissao = 'default', pushNaTela = null, liderTentou = false, notificar = true } = {}) {
  if (ouviu(r)) return 'feito';
  if (r === 'mudo') return 'mudo';
  if (pushNaTela === true) return 'feito';
  // o aviso do navegador da página respeita a chave da Aparência desligada (30/10/2026, revisão 2)
  if (permissao === 'granted' && notificar !== false) return 'aviso';
  return liderTentou ? 'nada' : 'som';
}

// ─── a recusa do servidor ──────────────────────────────────────────────────

/**
 * A leitura do op avisos falhou. e = o erro do crmSofiaApi (status; semToken quando nem saiu daqui), seguidas = as
 * recusas (401/403) seguidas até agora. → { parar } | { esperaMs } | {} (a reserva tenta de novo), mais seguidas.
 */
export function depoisDaFalha(e, seguidas = 0) {
  const st = Number(e?.status);
  if (e?.semToken === true) return { parar: true, seguidas };
  if (st === 404) return { parar: true, seguidas };
  if (st === 401 || st === 403) {
    const n = (Number(seguidas) || 0) + 1;
    return n >= MAX_RECUSAS ? { parar: true, seguidas: n } : { esperaMs: ESPERA_RECUSA_MS, seguidas: n };
  }
  if (st === 409) return { esperaMs: ESPERA_SEM_007_MS, seguidas: 0 };
  return { seguidas: 0 };   // REGRA LINEAR: rede ou 502, o título fica com o que tinha
}

// ─── a novidade de cada leitura ────────────────────────────────────────────

/**
 * conversas: as da resposta do op avisos; avisados: crmAvisados; desde: a última leitura boa (ISO);
 * antes: Map id → ultimaDoClienteEm da leitura anterior DESTA líder (null depois de recarregar).
 * → as conversas com fala nova, a de fala mais recente primeiro.
 */
export function novidades({ conversas = [], avisados = {}, desde = null, antes = null } = {}) {
  const corte = ms(desde);
  const out = [];
  for (const c of conversas || []) {
    const em = ms(c?.ultimaDoClienteEm);
    if (!c?.id || !Number.isFinite(em)) continue;
    const ja = ms(avisados?.[c.id]);
    if (Number.isFinite(ja) && ja >= em) continue;
    const anterior = antes?.has?.(c.id) ? ms(antes.get(c.id)) : Number.NaN;
    const ref = Number.isFinite(anterior) ? anterior : (Number.isFinite(corte) ? corte - FOLGA_GRAVACAO_MS : Number.NaN);
    if (!Number.isFinite(ref) || em > ref) out.push(c);
  }
  return out.sort((a, b) => ms(b.ultimaDoClienteEm) - ms(a.ultimaDoClienteEm));
}

export const lerVigiaDesde = (storage = armazem()) => { const v = lerJson(storage, CHAVE_VIGIA_DESDE); return typeof v === 'string' && Number.isFinite(ms(v)) ? v : null; };

/**
 * Uma leitura boa do op avisos ({ geradoEm, total, conversas, carimbo, mudou }). Grava a hora do servidor
 * (CHAVE_VIGIA_DESDE) e o total para as outras abas (CHAVE_VIGIA_TOTAL). Sem CHAVE_VIGIA_DESDE (a primeira vez do
 * navegador): só semeia, nada é novidade. Com mudou: false (o carimbo mandado bateu, o servidor nem leu as falas):
 * o total e o antes ficam como estão (totalAntes e antes desta líder), só a hora anda e o total ganha um em novo.
 * → { semeou, novas, total, antes, carimbo, mudou } (antes = o Map para a próxima leitura; carimbo = o que mandar)
 */
export function processarLeitura({ resposta, antes = null, totalAntes = null, storage = armazem(), agoraMs = Date.now() } = {}) {
  const geradoEm = Number.isFinite(ms(resposta?.geradoEm)) ? new Date(ms(resposta.geradoEm)).toISOString() : new Date(agoraMs).toISOString();
  const carimbo = typeof resposta?.carimbo === 'string' && resposta.carimbo ? resposta.carimbo : null;
  if (resposta?.mudou === false) {
    // sem a leitura anterior na memória não há o que manter: nada muda e a próxima vai sem carimbo (lê inteira)
    if (!antes) return { semeou: false, novas: [], total: Number.isFinite(Number(totalAntes)) ? Number(totalAntes) : null, antes: null, carimbo: null, mudou: false };
    const total = Number.isFinite(Number(totalAntes)) ? Number(totalAntes) : antes.size;
    gravarJson(storage, CHAVE_VIGIA_DESDE, geradoEm);
    gravarJson(storage, CHAVE_VIGIA_TOTAL, { total, em: agoraMs });
    return { semeou: false, novas: [], total, antes, carimbo, mudou: false };
  }
  const conversas = Array.isArray(resposta?.conversas) ? resposta.conversas : [];
  const total = Number.isFinite(Number(resposta?.total)) ? Number(resposta.total) : conversas.length;
  const desde = lerVigiaDesde(storage);
  const semeou = !desde && !antes;
  const novas = semeou ? [] : novidades({ conversas, avisados: lerAvisados({ storage, agoraMs }), desde, antes });
  gravarJson(storage, CHAVE_VIGIA_DESDE, geradoEm);
  gravarJson(storage, CHAVE_VIGIA_TOTAL, { total, em: agoraMs });
  return { semeou, novas, total, antes: new Map(conversas.filter(c => c?.id).map(c => [c.id, c.ultimaDoClienteEm || null])), carimbo, mudou: true };
}

/** O total que a líder escreveu (as outras abas leem para o título). Velho ou estranho: null. */
export function lerTotalDasAbas(storage = armazem(), agoraMs = Date.now()) {
  const v = lerJson(storage, CHAVE_VIGIA_TOTAL);
  const n = Number(v?.total);
  if (!v || !Number.isFinite(n) || n < 0 || !Number.isFinite(Number(v.em)) || agoraMs - Number(v.em) > TOTAL_VALIDADE_MS) return null;
  return Math.floor(n);
}

// ─── a chegada do push (CHAVE_PUSH_CHEGOU) ─────────────────────────────────
// { [tag]: { em, rec } }: em = a hora da fala no servidor (do payload), rec = Date.now() da chegada. Quem grava é
// cada aba do DNA ao receber MSG_PUSH_CHEGOU do service worker; sem armazenamento, a memória desta aba.

let memoriaChegadas = {};
const tagValida = (tag) => typeof tag === 'string' && tag.length <= 64 && (tag === TIPO_AVISO_MENSAGEM || tag.startsWith(PREFIXO_TAG_AVISO));

/** Só tag de aviso de mensagem, rec dentro do TTL e no máximo PUSH_CHEGOU_MAX (as chegadas mais novas ficam). */
export function podarChegadas(mapa, agoraMs = Date.now(), { ttl = PUSH_CHEGOU_TTL_MS, max = PUSH_CHEGOU_MAX } = {}) {
  const itens = Object.entries(mapa && typeof mapa === 'object' && !Array.isArray(mapa) ? mapa : {})
    .filter(([tag, v]) => tagValida(tag) && v && typeof v === 'object' && Number.isFinite(Number(v.rec)) && agoraMs - Number(v.rec) <= ttl)
    .map(([tag, v]) => [tag, { em: isoOuNulo(v.em), rec: Number(v.rec) }])
    .sort((a, b) => b[1].rec - a[1].rec)
    .slice(0, max);
  return Object.fromEntries(itens);
}

export function lerChegadas({ storage, agoraMs = Date.now() } = {}) {
  const st = qualArmazem(storage);
  if (!st) return podarChegadas(memoriaChegadas, agoraMs);
  try {
    const bruto = st.getItem(CHAVE_PUSH_CHEGOU);
    return podarChegadas(bruto ? JSON.parse(bruto) : {}, agoraMs);
  } catch { return podarChegadas(memoriaChegadas, agoraMs); }
}

/** O push desta tag chegou agora (relê antes; a hora da fala nunca volta no tempo). → o mapa novo, ou null (tag estranha). */
export function gravarChegada({ tag, em = null, storage, agoraMs = Date.now() } = {}) {
  if (!tagValida(tag)) return null;
  const st = qualArmazem(storage);
  const mapa = { ...lerChegadas({ storage: st, agoraMs }) };
  const antes = mapa[tag];
  const novo = isoOuNulo(em);
  const maior = antes?.em && (!novo || ms(antes.em) > ms(novo)) ? antes.em : novo;
  mapa[tag] = { em: maior, rec: agoraMs };
  const podado = podarChegadas(mapa, agoraMs);
  memoriaChegadas = podado;
  try { if (st) st.setItem(CHAVE_PUSH_CHEGOU, JSON.stringify(podado)); } catch { /* vale a memória desta aba */ }
  return podado;
}

/**
 * A chegada gravada cobre esta fala? registro = { em, rec } da tag; em = ultimaDoClienteEm da conversa.
 * Com as duas horas: a do push >= a da fala. Sem a hora (servidor antigo ou fala sem hora): chegou há menos de 10 min.
 */
export function chegadaCobre({ registro, em, agoraMs = Date.now() } = {}) {
  if (!registro || typeof registro !== 'object') return false;
  const rec = Number(registro.rec);
  if (!Number.isFinite(rec)) return false;
  const doPush = ms(registro.em);
  const daFala = ms(em);
  if (Number.isFinite(doPush) && Number.isFinite(daFala)) return doPush >= daFala;
  return agoraMs - rec < CHEGADA_SEM_EM_MS;
}

/** Só para os testes. */
export function _zerarChegadas() { memoriaChegadas = {}; }

/** As conversas da leva que o push já cobriu e as que faltam. */
export function separarPorChegada({ novas = [], storage, agoraMs = Date.now() } = {}) {
  const chegadas = lerChegadas({ storage, agoraMs });
  const cobertas = [];
  const faltam = [];
  for (const c of novas || []) (chegadaCobre({ registro: chegadas[tagAvisoMensagem(c?.id)], em: c?.ultimaDoClienteEm, agoraMs }) ? cobertas : faltam).push(c);
  return { cobertas, faltam };
}

// ─── o pedido de som à aba do DNA em foco (CHAVE_VIGIA_TOCAR → CHAVE_VIGIA_TOCOU) ───
// O evento storage só chega nas OUTRAS abas: a líder escreve o pedido e espera a resposta pelo evento; a aba em
// foco ouve o pedido, toca e escreve a resposta. A líder com foco não pede (toca ela, decidirSemPush).

const novoPedido = () => `p${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;

/** → a resposta da aba em foco ('tocou' | 'intervalo' | 'travado' | 'mudo') ou null em espera ms (ninguém em foco). */
export function pedirSomNaAbaComFoco({ storage, janela = null, relogio = RELOGIO, espera = ESPERA_TOCOU_MS, n = novoPedido() } = {}) {
  const st = qualArmazem(storage);
  return new Promise((resolver) => {
    if (!st || !janela || typeof janela.addEventListener !== 'function') { resolver(null); return; }
    let feito = false;
    let t = null;
    const ouvir = (e) => {
      if (e?.key !== CHAVE_VIGIA_TOCOU || !e.newValue) return;
      let v = null;
      try { v = JSON.parse(e.newValue); } catch { return; }
      if (v && v.n === n && RESPOSTAS_DO_SOM.includes(v.r)) fim(v.r);
    };
    function fim(r) {
      if (feito) return;
      feito = true;
      if (t != null) relogio.clearTimeout(t);
      try { janela.removeEventListener('storage', ouvir); } catch { /* segue */ }
      resolver(r);
    }
    janela.addEventListener('storage', ouvir);
    t = relogio.setTimeout(() => fim(null), espera);
    if (!gravarJson(st, CHAVE_VIGIA_TOCAR, { n, em: relogio.agora() })) fim(null);
  });
}

/**
 * A aba que recebe o evento storage: se é o pedido da líder e ESTA aba tem foco, toca e responde. → a resposta
 * gravada, ou null (não era pedido, pedido velho ou sem foco: não responde, a líder segue sem ela).
 */
export async function responderPedidoDeSom(e, { temFoco = () => false, tocar = async () => 'mudo', storage, agoraMs = Date.now() } = {}) {
  if (e?.key !== CHAVE_VIGIA_TOCAR || !e.newValue) return null;
  let v = null;
  try { v = JSON.parse(e.newValue); } catch { return null; }
  if (!v || typeof v.n !== 'string' || !v.n) return null;
  if (Number.isFinite(Number(v.em)) && Math.abs(agoraMs - Number(v.em)) > PEDIDO_VELHO_MS) return null;
  let foco = false;
  try { foco = temFoco() === true; } catch { foco = false; }
  if (!foco) return null;
  let r = 'travado';
  try { r = await tocar(); } catch { r = 'travado'; }
  if (!RESPOSTAS_DO_SOM.includes(r)) r = 'travado';
  gravarJson(qualArmazem(storage), CHAVE_VIGIA_TOCOU, { n: v.n, r });
  return r;
}

// ─── o vigia montado nesta aba (a Caixa sem foco deixa o aviso para ele) ────
// revisão 2 (30/10/2026): no computador com o vigia, a Caixa à vista e SEM foco não toca nem avisa (a líder avisa,
// com um som só); com foco, a Caixa segue tocando. No celular não há vigia e a Caixa avisa como antes.
let vigiasMontados = 0;
/** O VigiaCrm marca ao montar. → desmarcar() */
export function marcarVigiaMontado() {
  vigiasMontados += 1;
  let feito = false;
  return () => { if (!feito) { feito = true; vigiasMontados = Math.max(0, vigiasMontados - 1); } };
}
export const vigiaMontado = () => vigiasMontados > 0;

/**
 * A pessoa abriu a conversa (o visto da equipe): fecha os avisos do sistema dela, para o aviso velho não ficar na
 * Central de Notificações (e não calar o aviso da próxima fala). Nunca lança. → quantos fechou, ou null.
 */
export async function fecharAvisosDaConversa(conversaId, { sw = typeof navigator !== 'undefined' ? navigator.serviceWorker : null } = {}) {
  try {
    if (!conversaId) return null;
    const reg = sw && typeof sw.getRegistration === 'function' ? await sw.getRegistration() : null;
    if (!reg || typeof reg.getNotifications !== 'function') return null;
    const lista = await reg.getNotifications({ tag: tagAvisoMensagem(conversaId) });
    let n = 0;
    for (const x of Array.isArray(lista) ? lista : []) { try { x.close(); n += 1; } catch { /* segue */ } }
    return n;
  } catch { return null; }
}

// ─── o título ──────────────────────────────────────────────────────────────

const PREFIXO = /^\(\d+\+?\)\s/;
export const tirarPrefixo = (titulo) => String(titulo ?? '').replace(PREFIXO, '');
/** "(N) " na frente do título de agora (sem acumular prefixo); 0 ou sem dado: o título limpo. */
export function tituloComContagem(titulo, n) {
  const base = tirarPrefixo(titulo);
  const k = Math.floor(Number(n));
  return Number.isFinite(k) && k > 0 ? `(${k > 99 ? '99+' : k}) ${base}` : base;
}
export const naRotaDoCrm = (pathname) => typeof pathname === 'string' && (pathname === ROTA_CRM || pathname.startsWith(`${ROTA_CRM}/`));

// ─── as mensagens do service worker ────────────────────────────────────────

/**
 * A mensagem do service worker (clique no push com o DNA aberto): só caminho do CRM, nunca outro site.
 * origem = a deste DNA (a URL inteira do mesmo site vira o caminho).
 */
export function urlDoServiceWorker(dados, tipoEsperado, origem = null) {
  if (!dados || typeof dados !== 'object' || dados.tipo !== tipoEsperado || typeof dados.url !== 'string') return null;
  const u = origem && dados.url.startsWith(`${origem}/`) ? dados.url.slice(origem.length) : dados.url;
  return u.startsWith(`${ROTA_CRM}?`) || u === ROTA_CRM ? u : null;
}

/**
 * O leitor de navigator.serviceWorker 'message' (todas as abas do vigia). → aoMensagem(e) → o que fez
 * ('abriu' | 'chegou' | 'reinscreveu' | null), nunca lança:
 *   · MSG_ABRIR_CONVERSA { url }: navega pelo roteador (sem recarregar) e responde { ok: true } pela porta; sem
 *     resposta em ESPERA_ABRIR_MS o service worker navega a janela;
 *   · MSG_PUSH_CHEGOU { tag, conversaId, em, pedirSom }: grava a chegada e marca a fala como avisada; com pedirSom
 *     (só a janela em foco recebe) responde { tocou }: true se esta aba tocou (ou a fala JÁ estava avisada, ex.: a
 *     Caixa tocou antes), false se não tocou (travado, desligado, sem foco): aí o aviso do sistema sai com som;
 *   · { type: 'PUSH_SUBSCRIPTION_CHANGED' }: a inscrição do computador refeita (reinscrever).
 */
export function criarLeitorDoServiceWorker({
  navegar = () => {}, origem = null, focar = () => {}, temFoco = () => false, tocar = async () => 'mudo',
  reinscrever = () => {}, storage, agora = () => Date.now(),
} = {}) {
  return async function aoMensagem(e) {
    try {
      const d = e && e.data;
      if (!d || typeof d !== 'object') return null;
      const porta = e.ports && e.ports[0] && typeof e.ports[0].postMessage === 'function' ? e.ports[0] : null;
      const responder = (v) => { try { porta?.postMessage(v); } catch { /* o service worker segue sem a resposta */ } };
      if (d.type === 'PUSH_SUBSCRIPTION_CHANGED') {
        try { await reinscrever(); } catch { /* a reinscrição nunca lança; se lançar, a próxima montagem refaz */ }
        return 'reinscreveu';
      }
      if (d.tipo === MSG_ABRIR_CONVERSA) {
        const url = urlDoServiceWorker(d, MSG_ABRIR_CONVERSA, origem);
        if (!url) return null;
        try { focar(); } catch { /* segue */ }
        navegar(url);
        responder({ ok: true });
        return 'abriu';
      }
      if (d.tipo === MSG_PUSH_CHEGOU) {
        const agoraMs = agora();
        const st = qualArmazem(storage);
        const em = isoOuNulo(d.em);
        const id = typeof d.conversaId === 'string' && d.conversaId ? d.conversaId : null;
        // antes de marcar: a fala já estava avisada (a Caixa ou outra aba tocou)? então o sistema sai calado
        const ja = !!id && !!em && jaAvisado(lerAvisados({ storage: st, agoraMs }), id, em);
        gravarChegada({ tag: d.tag, em, storage: st, agoraMs });
        if (id && em) marcarAvisados([{ id, em }], { storage: st, agoraMs });
        if (d.pedirSom !== true) return 'chegou';
        if (ja) { responder({ tocou: true }); return 'chegou'; }
        let foco = false;
        try { foco = temFoco() === true; } catch { foco = false; }
        if (!foco) { responder({ tocou: false }); return 'chegou'; }
        let r = null;
        try { r = await tocar(); } catch { r = null; }
        // o som do CRM desligado nas preferências (r 'mudo'): o aviso do sistema também sai calado (revisão 2)
        responder({ tocou: ouviu(r) || r === 'mudo' });
        return 'chegou';
      }
      return null;
    } catch { return null; }
  };
}

// ─── o avisador da líder (uma decisão por leva) ────────────────────────────

/**
 * Tudo o que a líder faz com as conversas de fala nova de uma leitura (o desenho do som único, no cabeçalho).
 * As peças da tela entram por fora (os testes passam falsas):
 *   tocar() → o som NESTA aba com as preferências da pessoa ('tocou' | 'intervalo' | 'travado' | 'mudo');
 *   pedirSom() → a resposta da aba em foco ou null (pedirSomNaAbaComFoco);
 *   mostrarAviso(c) → true se o aviso do navegador da página saiu; pushNaTela(tag, em) → true | false | null (o
 *   aviso do sistema DAQUELA fala está na tela: um aviso velho da mesma conversa não conta);
 *   pushAtivo(), caixaAtiva(), temFoco(), permissao(), notificar() → o estado de agora (notificar = a chave da
 *   Aparência: desligada, nada de aviso do navegador da página).
 * → { avisar(novas) → 'caixa' | 'push' | o passo de depoisDoPedido, parar() }
 */
export function criarAvisador({
  tocar = async () => 'mudo', pedirSom = async () => null, mostrarAviso = () => false, pushNaTela = async () => null,
  pushAtivo = () => false, caixaAtiva = () => false, temFoco = () => false, permissao = () => 'default', notificar = () => true,
  storage, relogio = RELOGIO, esperaPush = ESPERA_PUSH_MS,
} = {}) {
  let ativo = true;
  const esperas = new Set();
  const seguro = (f, padrao) => { try { return f(); } catch { return padrao; } };
  const seguroAsync = async (f, padrao) => { try { return await f(); } catch { return padrao; } };
  const itensDe = (cs) => cs.map(c => ({ id: c.id, em: c.ultimaDoClienteEm }));
  const marcar = (cs) => { if (cs.length) marcarAvisados(itensDe(cs), { storage: qualArmazem(storage), agoraMs: relogio.agora() }); };
  const aindaNovas = (cs) => cs.filter(c => naoAvisados([{ id: c.id, em: c.ultimaDoClienteEm }], { storage: qualArmazem(storage), agoraMs: relogio.agora() }).length > 0);

  // o push daquela FALA está na tela? (pushNaTela recebe a hora: um aviso velho da mesma conversa não conta)
  const naTelaDe = (c) => seguroAsync(() => pushNaTela(tagAvisoMensagem(c.id), c.ultimaDoClienteEm), null);

  async function semPush(lista, decisao) {
    if (decisao === 'caixa') return 'caixa';
    // revisão 2 (30/10/2026): depois de cada espera, o que a Caixa (ou outra aba) avisou nesse meio tempo sai da leva
    let novas = aindaNovas(lista);
    if (!novas.length) return 'feito';
    const liderTentou = decisao === 'som';
    const r = liderTentou ? await seguroAsync(tocar, 'travado') : await seguroAsync(pedirSom, null);
    if (!ativo) return 'nada';
    novas = aindaNovas(novas);
    if (!novas.length) return 'feito';
    if (ouviu(r)) { marcar(novas); return 'feito'; }
    if (r === 'mudo') return 'mudo';
    // o aviso do navegador nunca sai para a fala com o push dela na tela (por conversa: as cobertas só marcam)
    const semTela = [];
    for (const c of novas) {
      if ((await naTelaDe(c)) === true) marcar([c]);
      else semTela.push(c);
    }
    if (!ativo) return 'nada';
    novas = aindaNovas(semTela);
    if (!novas.length) return 'feito';
    const passo = depoisDoPedido({ r, permissao: seguro(permissao, 'default'), pushNaTela: false, liderTentou, notificar: seguro(() => notificar() !== false, true) });
    if (passo === 'aviso') { if (seguro(() => mostrarAviso(novas[0]) === true, false)) marcar(novas); }
    else if (passo === 'som') { if (ouviu(await seguroAsync(tocar, 'travado'))) marcar(novas); }
    return passo;
  }

  // o push não cobriu (ainda): espera o servidor e confere de novo; o que ele não mandou cai no caminho sem push
  function conferirDepois(novas) {
    const t = relogio.setTimeout(async () => {
      esperas.delete(t);
      if (!ativo) return;
      try {
        const { cobertas, faltam } = separarPorChegada({ novas, storage: qualArmazem(storage), agoraMs: relogio.agora() });
        const semAviso = [];
        for (const c of faltam) {
          if ((await naTelaDe(c)) === true) cobertas.push(c);
          else semAviso.push(c);
        }
        if (!ativo) return;
        marcar(cobertas);
        // o que a Caixa (ou outra aba) avisou nesse meio tempo não avisa de novo
        const resto = aindaNovas(semAviso);
        if (resto.length) await semPush(resto, decidirSemPush({ caixaAtiva: seguro(caixaAtiva, false), temFoco: seguro(temFoco, false) }));
      } catch { /* segue: o "(N)" do título continua */ }
    }, esperaPush);
    esperas.add(t);
  }

  async function avisar(novas) {
    if (!ativo || !Array.isArray(novas) || !novas.length) return 'nada';
    const decisao = decidirAviso({ caixaAtiva: seguro(caixaAtiva, false), temFoco: seguro(temFoco, false), pushComputador: seguro(() => pushAtivo() === true, false) });
    if (decisao === 'caixa') return 'caixa';
    if (decisao === 'push') {
      const { cobertas, faltam } = separarPorChegada({ novas, storage: qualArmazem(storage), agoraMs: relogio.agora() });
      marcar(cobertas);
      if (faltam.length) conferirDepois(faltam);
      return 'push';
    }
    return semPush(novas, decisao);
  }

  return {
    avisar,
    parar() { ativo = false; for (const t of esperas) relogio.clearTimeout(t); esperas.clear(); },
  };
}

// ─── a aba líder ───────────────────────────────────────────────────────────

const RELOGIO = Object.freeze({
  agora: () => Date.now(),
  setTimeout: (f, t) => setTimeout(f, t),
  clearTimeout: (t) => clearTimeout(t),
  setInterval: (f, t) => setInterval(f, t),
  clearInterval: (t) => clearInterval(t),
});

/**
 * Uma aba líder por navegador. locks = navigator.locks (ou null: a reserva no localStorage).
 * aoMudar(lider) quando muda. → { iniciar(), parar(), lider() }
 */
export function criarLideranca({ locks = null, storage = armazem(), relogio = RELOGIO, aoMudar = () => {}, id = `v${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`, janela = null } = {}) {
  let lider = false;
  let ativo = false;
  let soltar = null;
  let abortar = null;
  let batida = null;
  const mudar = (v) => { if (v === lider) return; lider = v; try { aoMudar(v); } catch { /* segue */ } };

  // ── reserva: a batida no localStorage ──
  const lerLider = () => { const m = lerJson(storage, CHAVE_LIDER); return m && typeof m.id === 'string' && Number.isFinite(Number(m.em)) ? m : null; };
  function bater() {
    if (!ativo) return;
    if (!storage) { mudar(true); return; }   // sem armazenamento nenhum: cada aba por si
    const agora = relogio.agora();
    const m = lerLider();
    if (!m || m.id === id || agora - Number(m.em) > VALIDADE_LIDER_MS) {
      // o armazenamento que recusa a escrita (aba anônima antiga): cada aba por si, nunca sem vigia
      if (!gravarJson(storage, CHAVE_LIDER, { id, em: agora })) { mudar(true); return; }
      mudar(lerLider()?.id === id);
    } else mudar(false);
  }
  const aoArmazenar = (e) => { if (e?.key === CHAVE_LIDER && !e.newValue) bater(); };
  const largarReserva = () => { try { if (storage && lerLider()?.id === id) storage.removeItem(CHAVE_LIDER); } catch { /* ok */ } };

  function iniciarReserva() {
    if (!ativo || batida != null) return;
    bater();
    batida = relogio.setInterval(bater, BATIDA_LIDER_MS);
    janela?.addEventListener?.('storage', aoArmazenar);
    janela?.addEventListener?.('pagehide', largarReserva);
  }

  return {
    iniciar() {
      if (ativo) return;
      ativo = true;
      if (locks && typeof locks.request === 'function') {
        const ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
        abortar = () => ctrl?.abort();
        Promise.resolve()
          .then(() => locks.request(NOME_TRAVA, ctrl ? { signal: ctrl.signal } : {}, () => new Promise((res) => {
            if (!ativo) { res(); return; }
            soltar = res;
            mudar(true);
          })))
          // parou antes de ganhar a trava (AbortError): nada; o navegador recusou a trava: a reserva
          .catch((e) => { if (ativo && e?.name !== 'AbortError') iniciarReserva(); });
        return;
      }
      iniciarReserva();
    },
    parar() {
      if (!ativo) return;
      ativo = false;
      if (abortar) { abortar(); abortar = null; }
      if (soltar) { soltar(); soltar = null; }
      if (batida != null) { relogio.clearInterval(batida); batida = null; }
      janela?.removeEventListener?.('storage', aoArmazenar);
      janela?.removeEventListener?.('pagehide', largarReserva);
      largarReserva();
      mudar(false);
    },
    lider: () => lider,
  };
}

// ─── quando ler ────────────────────────────────────────────────────────────

/**
 * ler() faz a leitura e pode devolver { esperaMs } (espera especial: sem a crm-007, recusa do servidor) ou
 * { parar: true } (rollout off, sem token, 3 recusas). aoVivo() diz se o canal está provado; caixaAtiva() diz se a
 * Caixa está à vista neste navegador (o aviso do canal não antecipa: ela já lê na hora; a reserva continua, para o
 * antes e o desde não envelhecerem). minimo = ms ou (agoraMs) → ms entre duas leituras pelo aviso do canal.
 * → { iniciar(), parar(), sinal(), reagendar(), ativo() }
 */
export function criarAgenda({ ler, aoVivo = () => false, caixaAtiva = () => false, relogio = RELOGIO, minimo = minimoDoSinal } = {}) {
  let ativo = false;
  let emVoo = false;
  let pendente = false;
  // a hora (do banco, payload t do aviso 'mudou') do aviso mais novo ainda não lido: vai como ?apos= e o servidor
  // não responde com a memória de 10 s de antes dele (revisão 2: a fala que gerou o sinal nunca fica de fora)
  let sinalEm = null;
  let ultima = Number.NEGATIVE_INFINITY;
  let timer = null;
  let timerEm = 0;
  let porSinal = false;
  let especial = 0;
  const minimoAgora = (agora) => (typeof minimo === 'function' ? minimo(agora) : minimo);
  const limpar = () => { if (timer != null) { relogio.clearTimeout(timer); timer = null; } porSinal = false; };
  function agendar(espera, sinalizado = false) {
    limpar();
    if (!ativo) return;
    const e = Math.max(0, espera);
    timerEm = relogio.agora() + e;
    porSinal = sinalizado;
    timer = relogio.setTimeout(() => { timer = null; porSinal = false; rodar(); }, e);
  }
  function reservar() {
    const agora = relogio.agora();
    const espera = Math.max(esperaDaReserva({ aoVivo: !!aoVivo(), agoraMs: agora }), especial);
    agendar(Number.isFinite(ultima) ? ultima + espera - agora : 0);
  }
  async function rodar() {
    if (!ativo) return;
    if (emVoo) { pendente = true; return; }
    emVoo = true;
    ultima = relogio.agora();
    const apos = sinalEm;
    sinalEm = null;
    let r = null;
    try { r = await ler({ apos }); } catch { r = null; }
    emVoo = false;
    if (!ativo) return;
    if (r && r.parar) { ativo = false; limpar(); return; }
    especial = r && Number.isFinite(Number(r.esperaMs)) ? Number(r.esperaMs) : 0;
    // revisão 2: o sinal pendente pode não agendar nada (a Caixa ficou ativa no meio): a reserva nunca fica sem relógio
    if (pendente && !especial) { pendente = false; sinal(); if (ativo && timer == null) reservar(); return; }
    pendente = false;
    reservar();
  }
  function sinal(t = null) {
    if (!ativo) return;
    const tn = Number(t);
    if (Number.isFinite(tn) && tn > 0) sinalEm = Math.max(sinalEm || 0, tn);
    let comCaixa = false;
    try { comCaixa = caixaAtiva() === true; } catch { comCaixa = false; }
    if (comCaixa) return;   // a Caixa à vista já leu na hora
    if (emVoo) { pendente = true; return; }
    if (especial) return;   // sem a crm-007 ou recusado: o canal não adianta nada
    const agora = relogio.agora();
    const quando = Number.isFinite(ultima) ? Math.max(agora, ultima + minimoAgora(agora)) : agora;
    if (timer != null && timerEm <= quando) return;
    agendar(quando - agora, true);
  }
  return {
    iniciar() { if (ativo) return; ativo = true; agendar(0); },
    parar() { ativo = false; pendente = false; limpar(); },
    sinal,
    // o canal mudou de estado (provado ou caído): a reserva conta de novo desde a última leitura
    // (a leitura já marcada por um aviso do canal fica onde está)
    reagendar() { if (ativo && !emVoo && timer != null && !porSinal && Number.isFinite(ultima)) reservar(); },
    ativo: () => ativo,
  };
}
